import { useEffect, useState } from "react";
import { api, apiError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function Einstellungen() {
  const [tenant, setTenant] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setTenant(r.data.tenant));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/settings", tenant);
      toast.success("Einstellungen gespeichert. Daten werden automatisch in Dokumente übernommen.");
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  if (!tenant) return <div className="text-sm font-mono text-zinc-400">Laden…</div>;

  const f = (k) => (e) => setTenant({ ...tenant, [k]: e.target.value });

  return (
    <div className="max-w-3xl space-y-6" data-testid="einstellungen-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-wider text-zinc-400">Konfiguration</div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight mt-1">Einstellungen</h1>
      </div>

      <section className="bg-white border border-zinc-200 rounded-xl p-6 shadow-sm">
        <h2 className="font-display font-medium text-lg">Unternehmensprofil</h2>
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2"><Label>Firmenname</Label><Input value={tenant.company_name || ""} onChange={f("company_name")} data-testid="set-company-name" className="mt-1.5" /></div>
          <div><Label>Adresse</Label><Input value={tenant.address || ""} onChange={f("address")} data-testid="set-address" className="mt-1.5" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>PLZ</Label><Input value={tenant.zip || ""} onChange={f("zip")} className="mt-1.5" /></div>
            <div><Label>Ort</Label><Input value={tenant.city || ""} onChange={f("city")} className="mt-1.5" /></div>
          </div>
          <div><Label>Telefon</Label><Input value={tenant.phone || ""} onChange={f("phone")} className="mt-1.5" /></div>
          <div><Label>E-Mail</Label><Input value={tenant.email || ""} onChange={f("email")} className="mt-1.5" /></div>
          <div><Label>Website</Label><Input value={tenant.website || ""} onChange={f("website")} className="mt-1.5" /></div>
          <div><Label>Unternehmensart</Label><Input value={tenant.company_type || ""} onChange={f("company_type")} className="mt-1.5" /></div>
        </div>
      </section>

      <section className="bg-white border border-zinc-200 rounded-xl p-6 shadow-sm">
        <h2 className="font-display font-medium text-lg">Steuern & Finanzen</h2>
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div><Label>USt-IdNr.</Label><Input value={tenant.ust_id || ""} onChange={f("ust_id")} data-testid="set-ustid" className="mt-1.5" /></div>
          <div><Label>Steuernummer</Label><Input value={tenant.tax_number || ""} onChange={f("tax_number")} className="mt-1.5" /></div>
          <div><Label>IBAN</Label><Input value={tenant.bank_iban || ""} onChange={f("bank_iban")} data-testid="set-iban" className="mt-1.5 font-mono" /></div>
          <div><Label>BIC</Label><Input value={tenant.bank_bic || ""} onChange={f("bank_bic")} className="mt-1.5 font-mono" /></div>
          <div><Label>Standard-Steuersatz (%)</Label><Input type="number" value={tenant.tax_rate ?? 19} onChange={f("tax_rate")} data-testid="set-tax-rate" className="mt-1.5" /></div>
          <div><Label>Standard-Besteuerung</Label>
            <select value={tenant.tax_mode_default || "differenz"} onChange={f("tax_mode_default")} data-testid="set-tax-mode" className="mt-1.5 w-full border border-zinc-200 rounded-lg px-3 py-2 text-sm bg-white">
              <option value="differenz">§25a Differenzbesteuerung (Standard)</option>
              <option value="regel">19 % Umsatzsteuer</option>
              <option value="frei">0 % / steuerfrei</option>
              <option value="ku19">§19 UStG / Kleinunternehmer</option>
            </select>
          </div>
        </div>
        <label className="flex items-center gap-3 mt-4 cursor-pointer" data-testid="set-auto-email">
          <input type="checkbox" checked={!!tenant.invoice_auto_email} onChange={(e) => setTenant({ ...tenant, invoice_auto_email: e.target.checked })} className="w-4 h-4 accent-zinc-900" />
          <span className="text-sm text-zinc-700">Rechnung nach Verkauf automatisch per E-Mail an den Kunden senden (wenn E-Mail hinterlegt)</span>
        </label>
        <p className="text-xs text-zinc-400 mt-4">Die steuerliche Logik ist konfigurierbar – keine pauschalen Annahmen. Nummernkreise (AN/VK/RE/AV/KD/VE) laufen automatisch pro Unternehmen und Jahr.</p>
      </section>

      <Button onClick={save} disabled={busy} className="bg-zinc-900 hover:bg-zinc-800 text-white" data-testid="settings-save-button">
        {busy ? "Speichern…" : "Einstellungen speichern"}
      </Button>
    </div>
  );
}
